import {AxiosError} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

import {MyPower} from '@eksab/features/store/badges/types';
import {useInvalidateMyPowers} from '@eksab/features/profile/hooks';

type PowerConsumptionTypes =
  | {
      competition_entry_id: number;
    }
  | {
      news_item_id: number;
    };

type PowerConsumptionParams = PowerConsumptionTypes & {id: number};
export function useConsumePowerMutation(options?: UseMutationOptions<MyPower, AxiosError, PowerConsumptionParams>) {
  const invalidateMyPowers = useInvalidateMyPowers();
  return useMutation<MyPower, AxiosError, PowerConsumptionParams>(
    ({id, ...rest}) => api.post(`v1/user-powers/${id}/consume`, rest),
    {
      ...options,
      onSuccess: (...params) => {
        options?.onSuccess?.(...params);
        invalidateMyPowers();
      },
    },
  );
}
